import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { downloadErrorAlert, saveAsFile } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/activity-report/ActivityReportAction";
import * as uiHelpers from "../ActivityReportUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useActivityReportUIContext } from "../ActivityReportUIContext";

export function ActivityReportTable() {
  // Activity Report UI Context
  const activityReportUIContext = useActivityReportUIContext();
  const activityReportUIProps = useMemo(() => {
    return {
      queryParams: activityReportUIContext.queryParams,
      setQueryParams: activityReportUIContext.setQueryParams,
      openExplanationModal: activityReportUIContext.openExplanationModal
    };
  }, [activityReportUIContext]);

  // Getting curret state of Activity Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.activityReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;

  // Activity Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getActivityReport(activityReportUIProps.queryParams));
    return () => dispatch(actions.cleanActivitiesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityReportUIProps.queryParams, dispatch]);

  /** Belli Bir Eki İndirir */
  const downloadAttachment = (id, filename) => {
    dispatch(actions.downloadAttachment(id)).then(file => {
      if (!file) {
        downloadErrorAlert();
        return;
      }
      saveAsFile(file, filename);
    })
  }

  // Table columns
  const columns = [
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "student",
      text: "Öğrenci",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "activityType",
      text: "Faaliyet Türü",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "200px",
      }
    },
    {
      dataField: "title",
      text: "Başlık",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "200px",
      }
    },
    {
      dataField: "explanation",
      text: "Açıklama",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px",
      }
    },
    {
      dataField: "date",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px",
      }
    },
    {
      dataField: "attachmentName",
      text: "Ek",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => (
        <a href="javascript:" onClick={() => downloadAttachment(row.activityId, row.attachmentName)}>{cell}</a>
      ),
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openExplanationModal: activityReportUIProps.openExplanationModal
      },
      classes: "text-right pr-4",
      headerClasses: "text-right pr-0",
      style: {
        minWidth: "90px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: activityReportUIProps.queryParams.pageSize,
    page: activityReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                activityReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}